<section class="main">
    <div class="table-title">
        <div class="head-button-container">
            <div class="head-button">
                <button class="r-btn" (click)="onRefreshTable()"><i class="icon bi bi-arrow-clockwise"></i></button>
            </div>
            <div class="head-button">
                <button class="r-btn" (click)="backToMainTable()"><i class="icon bi bi-arrow-left"></i></button>
            </div>
            <div class="master-details-title">
                <i class="bi bi-sliders"></i> Possible Matchings: {{ ecuProducer }} ~ {{ ecuBuild }} ~ {{ versionName }} ~ {{ dcf }}
            </div>
        </div>

        <div class="act-search-bar">
            <app-search-bar [value]="'WinOls'" (searchValue)="onSearchInput($event)"></app-search-bar>
        </div>
    </div>

    <div class="table-container" *ngIf="allPossibleMatchings.length > 0">
        <table>
            <tr class="header">
                <th *ngFor="let column of displayedColumns" (click)="onSort(column)" class="sortable-header">
                    <div class="header-content">
                        {{ column | shorten: 45 }}
                        <i *ngIf="sortColumn === column" class="bi"
                           [class.bi-caret-up-fill]="sortDirection === 'asc'"
                           [class.bi-caret-down-fill]="sortDirection === 'desc'"></i>
                    </div>
                </th>
                <th class="actions-header">Actions</th>
            </tr>
            <tr *ngFor="let element of allPossibleMatchings; let i = index" class="body-columns">
                <td *ngFor="let column of displayedColumns">{{ formatDate(element[column], column) | shorten: 1000 }}</td>
                <td class="actions">
                    <button class="table-buttons"
                            (click)="downloadVersionFromPureOriginals(+element.id, element.versionWinOlsReference)">
                        <i class="bi bi-file-earmark-arrow-down"></i>
                    </button>
                    <button class="table-buttons car-button"
                            (click)="openPureOriginalDetails(+element.pureOriginalBaseId)">
                        <i class="bi bi-car-front-fill"></i>
                    </button>
                </td>
            </tr>
        </table>
    </div>
    <div *ngIf="allPossibleMatchings.length < 1">
        <app-skeleton-table></app-skeleton-table>
    </div>
</section>
